import { isCanceled } from './isCanceled'
import { isRequested } from './isRequested'
import { BankingCard } from './types'

export const canCancelCard = (card: BankingCard | null | undefined): boolean => {
  return card?._policies?.cancel?.can === true && !isRequested(card) && !isCanceled(card)
}
